import { getLocales } from 'assets/locales/Locale';
import { intersection, isEmpty } from 'lodash';
import ClaimEmailTemplate from 'models/core/claimEmailTemplate/Model.ClaimEmailTemplate';
import ClaimJobEmailTemplate from 'models/core/claimJobEmailTemplate/Model.ClaimJobEmailTemplate';
import ClaimJobStatusCode from 'models/enums/ClaimJobStatusCode';
import ClaimStatusCode from 'models/enums/ClaimStatusCode';

export function getNextStatus(
  emailTemplates: ClaimEmailTemplate[],
  statusInfo: Model.ClaimStatusInfo,
  currentPermissions: Auth.Permission[],
  currentStatus?: Model.Enum.ClaimStatusCode,
  claim?: Model.IClaim
) {
  let nextStatusList: Model.NextClaimStatus[] = [];
  if (!statusInfo && !emailTemplates) return { nextStatusList, statusTranslations: {} };
  const currentStatusInfo = statusInfo && currentStatus && statusInfo[currentStatus];
  let availableStatuses: Model.Enum.ClaimStatusCode[] = [...(currentStatusInfo?.nextStatusList ?? [])];

  const { lang } = getLocales();
  const statusTranslations: Record<string, string> = {};
  for (const status of availableStatuses) {
    const statusTranslated = lang[status] ?? status;
    const [primary, secondary, reason] = status.split('_');
    const [primaryTranslated, secondaryTranslated, reasonTranslated] = statusTranslated.split('_');

    statusTranslations[primary] = primaryTranslated;
    statusTranslations[secondary] = secondaryTranslated;
    statusTranslations[reason] = reasonTranslated;
  }

  if (currentStatusInfo && intersection(currentStatusInfo.permissions, currentPermissions).length) {
    const claimJobs = claim?.claimJobs || [];
    if (!isEmpty(claimJobs)) {
      const hasNonCancelledJob = claimJobs?.some((it) => it.statusCode !== ClaimJobStatusCode.CANCELED_VOID);
      const hasNonDeniedJob = claimJobs?.some((it) => it.statusCode !== ClaimJobStatusCode.DENIED_DECLINED);
      const hasNonPaidClosedJob = claimJobs?.some((it) => it.statusCode !== ClaimJobStatusCode.PAID_CLOSED_PAID);

      availableStatuses = availableStatuses?.filter((code) => {
        if (
          (code === ClaimStatusCode.CANCELED_VOID && hasNonCancelledJob) ||
          (code === ClaimStatusCode.DENIED_DECLINED && hasNonDeniedJob) ||
          (code === ClaimStatusCode.PAID_CLOSED_PAID && hasNonPaidClosedJob)
        )
          return false;
        return true;
      });
    }
    //#endregion

    nextStatusList = availableStatuses?.map((nextStatus) => {
      const { permissions } = statusInfo[nextStatus] || {};
      const [primary, secondary, reason] = nextStatus.split('_');
      return {
        nextStatus,
        statusInfo: { primary, secondary, reason },
        ownershipAllowed: intersection(permissions, currentPermissions).length > 0,
        emailTemplate: emailTemplates?.find((it) => it.claimStatus === nextStatus)?.toJSON(),
      };
    });

    return { currentStatusInfo, nextStatusList, statusTranslations };
  }

  return { nextStatusList, statusTranslations };
}
export function getNextClaimJobStatus(
  emailTemplates: ClaimJobEmailTemplate[],
  statusInfo: Model.ClaimJobStatusInfo,
  currentPermissions: Auth.Permission[],
  currentStatus?: Model.Enum.ClaimJobStatusCode
) {
  let nextStatusList: Model.NextClaimJobStatus[] = [];

  const { lang } = getLocales();

  if (!statusInfo && !emailTemplates) return { nextStatusList, statusTranslations: {} };
  const currentStatusInfo = statusInfo && currentStatus && statusInfo[currentStatus];
  const statusTranslations: Record<string, string> = {};
  for (const status of currentStatusInfo?.nextStatusList ?? []) {
    const statusTranslated = lang[status] ?? status;
    const [primary, secondary, reason] = status.split('_');
    const [primaryTranslated, secondaryTranslated, reasonTranslated] = statusTranslated.split('_');

    statusTranslations[primary] = primaryTranslated;
    statusTranslations[secondary] = secondaryTranslated;
    statusTranslations[reason] = reasonTranslated;
  }

  if (currentStatusInfo && intersection(currentStatusInfo.permissions, currentPermissions).length) {
    nextStatusList = currentStatusInfo.nextStatusList?.map((nextStatus) => {
      const { permissions } = statusInfo[nextStatus] || {};
      const [primary, secondary, reason] = nextStatus.split('_');
      return {
        nextStatus,
        statusInfo: { primary, secondary, reason },
        ownershipAllowed: intersection(permissions, currentPermissions).length > 0,
        emailTemplate: emailTemplates?.find((it) => it.claimJobStatus === nextStatus)?.toJSON(),
      };
    });
    return { currentStatusInfo, nextStatusList, statusTranslations };
  }

  return { nextStatusList, statusTranslations };
}
